/**
 * ParamInfo
 */

import Config from '../Config';
import Util from '../Util';

class ParamInfo {

	private param: any[];

	constructor() {
		this.param = [];
  }

	public setLink( url: string, param: string ) {
		if( url.indexOf('?') !== -1 ) {
			return `${url}&${param}`;
		}

		return `${url}?${param}`;
	}

	public setParamByUrl() {
		const _param = Util.getParams();

		if ( jQuery.isEmptyObject( _param ) ) {
			return;
		}

		this.param = [];
		for ( const item in _param ) {
			if ( Object.prototype.hasOwnProperty.call( _param, item ) ) {
				this.param.push( [ item, _param[ item ] || '' ] );
			}
		}
	}

	public setParamByHash() {
		const _hash = Util.getHash();
		const _hashs: any = Util.hashs( _hash || '' );

		if ( jQuery.isEmptyObject( _hashs ) ) {
			return;
		}

		this.param = [];
		for ( const item in _hashs ) {
			if ( Object.prototype.hasOwnProperty.call( _hashs, item ) ) {
				this.param.push( [ item, _hashs[ item ] ] );
			}
		}
	}

	public removeVag( str: string ) {
		if ( !str ) {
			return '';
		}

		str = str + '';
		str = str.replace( /#/g, '' );
		str = str.replace( /\s/g, '' );
		return str;
	}

	public removeParam( param: any ) {
		for ( let i = 0, len = this.param.length; len > i; i++ ) {
			if ( param[ 0 ] === this.param[ i ][ 0 ] ) {
				this.param.splice( i, 1 );
				break;
			}
		}
	}

	public getParamByKey( key: string ) {
		for ( let i = 0, len = this.param.length; len > i; i++ ) {
			if ( key === this.param[ i ][ 0 ] ) {
				return this.param[ i ][ 1 ] || '';
			}
		}

		return '';
	}

	public setParam( param: any ) {
		this.removeParam( param );
		this.param.push( param );
	}

	public getParam() {
		let tmp = ``;
		// for( let item of this.param ){
		// 	tmp += `&${ item[ 0 ] }=${ item[ 1 ] }`
		// }

		this.param.forEach( ( item ) => {
			tmp += `&${ item[ 0 ] }=${ item[ 1 ] }`;
		});

		return tmp;
	}

	public getParamIgnore( ignore: string ) {
		let tmp = ``;

		this.param.forEach( ( item ) => {
			if ( item[ 0 ] !== ignore ) {
				tmp += `&${ item[ 0 ] }=${ item[ 1 ] }`;
			}
		});

		return tmp;
	}
}

export default ParamInfo;
